import { useState } from "react"
import { AnimatedChord } from "./AnimatedChord"
import { FlexRowOne, FlexRowTwo } from "../../Layouts/FlexRows"
import './ChordSteps.scss'
import { NotesSelect } from "../NoteButtons/NotesSelect"

export function ChordSteps(props:{tonic:number}){
    const [chordIndex, setChordIndex] = useState(0)
    const [tonic, setTonic] = useState(props.tonic)
    const getChordGroup = (index:number) => {
        const radius:number = 100
        return(
            <AnimatedChord  key={'animatedChord' + chordIndex + formulaIndex} 
                            radius={radius} 
                            rootPosition={chordIndex} 
                            keyTonic={tonic} 
                            formula={formulas[index]} 
                            onComplete={()=>{}}/>
        )
    }
    const formulas:number[][] = [[0,2,4],[0,2,4,6],[0,1,4], [0,3,4],[0,2,4,5],[0,4]]
    const [formulaIndex, setFormulaIndex] = useState(0)
    const selectFormula = (e:any) => {
        setFormulaIndex(e.target.value)
        setChordIndex(0)
    }
    const showChord = (index:number) => {
        setChordIndex(index)
    }
    const getButtons = () => {
        const buttons:JSX.Element[] = []
        for(let i = 0; i < 7; i++){
            const isDisabled:boolean = (i === chordIndex)
            const className:string = (i === chordIndex) ? 'selected' : ''
            buttons.push(<button key={i} className={className} type='button' disabled={isDisabled} onClick={()=>{showChord(i)}}>{i + 1}</button>)
        }
        return buttons
    }
    const changeTonic = (fresh_tonic:number) => {
        setTonic(fresh_tonic)
        setChordIndex(0)
    }
    return( 
        <div>
            <div className="formula-selector">
                <FlexRowTwo columnOneFlex={1} columnTwoFlex={1}>
                    <NotesSelect tonic={tonic} onChange={changeTonic}/>
                    <select value={formulaIndex} onChange={selectFormula}>
                        <option value={0}>Triad 1-3-5</option>
                        <option value={1}>Seventh 1-3-5-7</option>
                        <option value={2}>Sus2 1-2-5</option>
                        <option value={3}>Sus4 1-4-5</option>
                        <option value={4}>Sixth Chord 1-3-5-6</option>
                        <option value={5}>Power Chord 1-5</option>
                    </select>
                </FlexRowTwo>
                
            </div>
            <FlexRowOne classNames={['column-container']}>
                <div className="main-column">
                    {getChordGroup(formulaIndex)}
                    <div>
                        <h3>The {chordIndex + 1} Chord</h3>
                        <div>
                            {getButtons()}
                        </div>
                    </div>
                </div>
            </FlexRowOne>
        </div>
    )
}